export default "__VITE_ASSET__81ba2e13__"